import moment from "moment";
import {
  SET_WORKING_HOURS,
  CLOSURES_UPDATE,
  UPDATE_WORKING_HOURS,
  ADMIN_SETTINGS_DAY_FROM_UPDATE,
  ADMIN_SETTINGS_DAY_TO_UPDATE,
  ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE,
  HANDLE_REQUEST_CLOSE,
  ADMIN_SETTINGS_CHANGE_ADD_STATE,
  ADMIN_SETTINGS_CHANGE_EDIT_STATE,
  EDIT_CLOSURE_RESPONSE,
  FAIL_RESPONSE_MESSAGE,
  DELETE_CLOSURES_RESPONSE,
  ADMIN_SETTINGS_CANCEL_CLICK,
  CLOSURE_ON_HIDE_LOADER,
  CLOSURE_ON_SHOW_LOADER,
  WORKING_HOURS_HIDE_LOADER,
  WORKING_HOURS_SHOW_LOADER,
  DAY_ERROR,
  DAY_ERROR_RESPONSE,
  BUSINESS_PROFILE_CANCEL,
  BUSINESS_PROFILE_SAVE_RESPONSE,
  BUSINESS_PROFILE_IMAGE_FILE,
  BUSINESS_PROFILE_IMAGE_FILE_RESPONSE,
  WORKING_HOURS_TOGGLE_MODAL,
  WORKING_HOURS_NEW_REQUEST_CLOSE,
  ADMIN_SETTINGS_ON_HIDE_LOADER,
  ADMIN_SETTINGS_ON_SHOW_LOADER,
  BUSSINESS_GALLARY_IMAGE_FILE,
  BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS,
  BUSSINESS_GALLARY_IMAGE_FILE_ERROR,
  BUSSINESS_GALLARY_IMAGE_FILE_REMOVE,
} from "../constants/ActionTypes";

const initialState = {
  operations: {},
  defaultOperations: {},
  businessClosure: {},
  toggle: false,
  alertMessage: "",
  showMessage: false,
  addClosureState: true,
  editClosureState: false,
  errorMessage: false,
  closureLoader: false,
  workingHoursLoader: false,
  errors: {},
  businessProfile: {
    businessname: "",
    website: "",
    email: "",
    phonenumber: "",
    description: "",
    address: "",
    _id: "",
    firstname: "",
    lastname: "",
    title: "",
    newPassword: "",
    confirmPassword: "",
  },
  imageFile: null,
  gallaryFile:[],
  gallaryFiles:[],
  businessProfileCancel: {
    businessname: "",
    website: "",
    email: "",
    phonenumber: "",
    description: "",
    address: "",
    _id: "",
    firstname: "",
    lastname: "",
    title: "",
    newPassword: "",
    confirmPassword: "",
  },
  imageFileCancel: null,
  workingHoursModal: false,
  newWorkingHours: false,
  noOfEmployee: 0,
  imageid: "",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_WORKING_HOURS: {
      const {
        operations,
        business_closure,
        email,
        phonenumber,
        address,
        businessname,
        firstname,
        lastname,
        title,
        userId,
        no_of_employee,
      } = payload;
      console.log("TCL: payload1111", payload)
      console.log("PARTH : TCL: no_of_employee", no_of_employee)
      console.log("TCL: operations", operations)
      const { name, website, description, _id, logo,photos } = businessname;
      console.log("TCL: businessname", businessname)
      console.log("TCL: logo", logo)

      return {
        ...state,
        defaultOperations: { ...operations },
        operations,
        businessClosure: business_closure,
        businessProfile: {
          ...state.businessProfile,
          email,
          phonenumber,
          address,
          businessname: name,
          website,
          description,
          _id,
          firstname,
          lastname,
          title,
          userId,
        },
        businessProfileCancel: {
          ...state.businessProfileCancel,
          email,
          phonenumber,
          address,
          businessname,
          website,
          description,
          _id,
          firstname,
          lastname,
          title,
          userId,
        },
        imageFile: logo,
        imageFileCancel: logo,
        noOfEmployee: no_of_employee,
        gallaryFiles:photos
      };
    }
    case CLOSURES_UPDATE: {
      const { from, to, full_day_closed, location, _id, isNew, reason_for_closure } = payload;
      return {
        ...state,
        businessClosure: [
          ...state.businessClosure,
          { from, to, full_day_closed, location, _id, isNew, reason_for_closure },
        ],
        alertMessage: "vibo.notification.businessClosure.add",
        showMessage: true,
        workingHoursLoader: false,
        newWorkingHours: true,
      };
    }
    case UPDATE_WORKING_HOURS: {
      const keys = Object.keys(state.operations);
      const ans = keys.includes(payload);
      const { operations, errors } = state;

      if (ans) {
        delete operations[payload];
        delete errors[payload];
        return {
          ...state,
          operations,
          toggle: !state.toggle,
          errors,
        };
      }

      return {
        ...state,
        operations: {
          ...state.operations,
          [payload]: {
            from: moment(`${moment().format("YYYY-MM-DD")} 9:00`),
            to: moment(`${moment().format("YYYY-MM-DD")} 21:00`),
          },
        },
        toggle: !state.toggle,
      };
    }

    case ADMIN_SETTINGS_DAY_FROM_UPDATE: {
      return {
        ...state,
        operations: {
          ...state.operations,
          [payload.day]: {
            ...state.operations[payload.day],
            from: payload.value,
          },
        },
      };
    }

    case ADMIN_SETTINGS_DAY_TO_UPDATE:
      return {
        ...state,
        operations: {
          ...state.operations,
          [payload.day]: {
            ...state.operations[payload.day],
            to: payload.value,
          },
        },
      };

    case ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE:
      const newData = JSON.parse(localStorage.getItem('user-data'));
      newData.business.business_locations[0].operations = state.operations;
      localStorage.setItem('user-data', JSON.stringify(newData));
      return {
        ...state,
        alertMessage: "vibo.notification.operations.update",
        showMessage: true,
        closureLoader: false,
        operations: payload.operations,
        defaultOperations: payload.operations,
      };

    case HANDLE_REQUEST_CLOSE: {
      return {
        ...state,
        showMessage: false,
        errorMessage: false,
        closureLoader: false,
        workingHoursLoader: false,
      };
    }

    case ADMIN_SETTINGS_CHANGE_ADD_STATE:
      return { ...state, addClosureState: payload, editClosureState: !payload };

    case ADMIN_SETTINGS_CHANGE_EDIT_STATE:
      return { ...state, editClosureState: payload, addClosureState: !payload };

    case EDIT_CLOSURE_RESPONSE: {
      const { from, to, full_day_closed, location, _id, isNew, reason_for_closure } = payload;
      const businessClosure = state.businessClosure.filter(item => item._id !== _id);

      return {
        ...state,
        alertMessage: "vibo.notification.businessClosure.update",
        showMessage: true,
        businessClosure: [
          ...businessClosure,
          { from, to, full_day_closed, location, _id, isNew, reason_for_closure },
        ],
        addClosureState: true,
        editClosureState: false,
        newWorkingHours: true,
        closureLoader: false,
      };
    }

    case DELETE_CLOSURES_RESPONSE: {
      const { selection } = payload;
      let { businessClosure } = state;
      selection.forEach(element => {
        businessClosure = businessClosure.filter(item => item._id !== element);
      });

      return {
        ...state,
        alertMessage: "vibo.notification.businessClosure.delete",
        showMessage: true,
        businessClosure,
      };
    }

    case FAIL_RESPONSE_MESSAGE:
      return {
        ...state,
        alertMessage: payload,
        errorMessage: true,
        closureLoader: false,
        workingHoursLoader: false,
      };

    case BUSSINESS_GALLARY_IMAGE_FILE_ERROR:
      
      return {
        ...state,
        alertMessage: payload,
        errorMessage: true,
      }

    case ADMIN_SETTINGS_CANCEL_CLICK:
      return {
        ...state,
        operations: { ...state.defaultOperations },
        errors: {},
      };

    case CLOSURE_ON_HIDE_LOADER:
      return { ...state, closureLoader: false };
    case CLOSURE_ON_SHOW_LOADER:
      return { ...state, closureLoader: true };
    case WORKING_HOURS_HIDE_LOADER:
      return { ...state, workingHoursLoader: false };
    case WORKING_HOURS_SHOW_LOADER:
      return { ...state, workingHoursLoader: true };

    case DAY_ERROR:
      return {
        ...state,
        errors: { ...state.errors, [payload.day]: payload.error },
      };

    case DAY_ERROR_RESPONSE: {
      const { errors } = state;
      delete errors[payload.day];
      return { ...state, errors };
    }

    case BUSINESS_PROFILE_CANCEL:
      return {
        ...state,
        businessProfile: {
          ...state.businessProfile,
          ...state.businessProfileCancel,
        },
        imageFile: state.imageFileCancel,
        // alertMessage: "Business Profile Reset Successfully",
        // closureLoader: false,
        // showMessage: true,
      };

    case BUSINESS_PROFILE_SAVE_RESPONSE:
      // console.log("payloadpayload", state, payload, state.imageFile)
      return {
        ...state,
        businessProfileCancel: {
          ...state.businessProfile,
        },
        imageFileCancel: state.imageFile,
        alertMessage: "vibo.notification.businessProfile.update",
        closureLoader: false,
        showMessage: true,
        imageid: (payload)?payload._id:((state.imageFile)?state.imageFile._id:"")
      };

    case BUSINESS_PROFILE_IMAGE_FILE:
      let imageid = "";
      if(state.imageFile != null && state.imageFile._id != undefined) {
        imageid= state.imageFile._id;
      }
      if(state.imageid != "") {
        imageid= state.imageid;
      }
      return { ...state, imageFile: payload, imageid};
    case BUSSINESS_GALLARY_IMAGE_FILE :
      var {gallaryFile} = state;
      gallaryFile.push(payload[0]);
      console.log("GF",gallaryFile);
      
      return{...state,gallaryFile};
    
    case BUSSINESS_GALLARY_IMAGE_FILE_REMOVE :
        var del=state.gallaryFile
        console.log("PAYLOAD",payload,del);
        
        del = del.filter(item =>{
          return payload.name != item.name
        });
        console.log("DEL",del);
        
        return{...state,gallaryFile:del};

    case BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS :
      return{...state,gallaryFile:[]};
      
    case WORKING_HOURS_TOGGLE_MODAL:
      return { ...state, workingHoursModal: !state.workingHoursModal };

    case WORKING_HOURS_NEW_REQUEST_CLOSE: {
      let { businessClosure } = state;
      businessClosure = businessClosure.map(item => {
        if (item.isNew) {
          delete item.isNew;
        }
        return item;
      });

      return { ...state, newWorkingHours: false, businessClosure };
    }

    case ADMIN_SETTINGS_ON_HIDE_LOADER:
      return { ...state, workingHoursLoader: false };

    case ADMIN_SETTINGS_ON_SHOW_LOADER: {
      return { ...state, workingHoursLoader: true };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/AdminSettings.js